import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Footer from "../components/Footer";

export default function News({ showFooter = true, isPage = true, preview = false }) {
  const navigate = useNavigate();
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);

  const API = process.env.PARCEL_API_URL;

  useEffect(() => {
    if (!API) return;

    axios
      .get(`${API}/api/news`)
      .then((res) => setNewsData(res.data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, [API]);

  const displayData = preview ? newsData.slice(0, 3) : newsData;

  // 🔥 Skeleton Card
  const SkeletonCard = () => (
    <div className="bg-white rounded-xl shadow-md overflow-hidden animate-pulse">
      <div className="w-full h-44 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200"></div>
      <div className="p-5 space-y-2">
        <div className="h-4 bg-gray-200 rounded w-3/4"></div>
        <div className="h-3 bg-gray-200 rounded w-full"></div>
        <div className="h-3 bg-gray-200 rounded w-5/6"></div>
      </div>
    </div>
  );

  return (
    <div className={`bg-orange-50 flex flex-col ${isPage ? "min-h-screen" : ""}`}>
      
      <section className={`px-6 md:px-24 ${isPage ? "py-16" : "py-8"} flex-grow`}>

        {/* 🔙 Back button */}
        {isPage && (
          <button
            onClick={() => navigate("/")}
            className="mb-6 text-orange-500 font-semibold hover:underline"
          >
            ← Back to Home Page
          </button>
        )}

        {/* 🔥 TITLE */}
        <h2 className="text-3xl font-bold text-center mb-10">
          Latest <span className="text-orange-500">News</span>
        </h2>

        {/* 🔥 GRID */}
        <div className="w-full">

          {loading ? (
            <>
              {/* 📱 Mobile (2 cols → 8 items) */}
              <div className="grid grid-cols-2 gap-6 md:hidden">
                {Array(8).fill(0).map((_, i) => (
                  <SkeletonCard key={i} />
                ))}
              </div>

              {/* 📱 Tablet (2-3 cols → 10 items) */}
              <div className="hidden md:grid lg:hidden grid-cols-3 gap-6">
                {Array(10).fill(0).map((_, i) => (
                  <SkeletonCard key={i} />
                ))}
              </div>

              {/* 💻 Desktop (3 cols → 12 items) */}
              <div className="hidden lg:grid grid-cols-3 gap-6">
                {Array(12).fill(0).map((_, i) => (
                  <SkeletonCard key={i} />
                ))}
              </div>
            </>
          ) : displayData.length > 0 ? (

            <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
              {displayData.map((item) => (
                <motion.div
                  key={item._id}
                  onClick={() => {
                    if (preview) {
                      navigate("/news");
                    } else {
                      navigate(`/news/${item._id}`);
                    }
                  }}
                  whileHover={{ scale: 1.04 }}
                  className="bg-white rounded-xl shadow-md cursor-pointer overflow-hidden hover:shadow-xl transition"
                >
                  
                  {/* IMAGE */}
                  {item.image && (
                    <div className="w-full h-44 bg-gray-100 flex items-center justify-center overflow-hidden">
                      <img
                        src={item.image}
                        alt={item.title}
                        className="h-full w-full object-contain transition duration-300 hover:scale-105"
                      />
                    </div>
                  )}

                  {/* CONTENT */}
                  <div className="p-5">
                    <h3 className="font-bold text-orange-500 mb-2 line-clamp-2">
                      {item.title}
                    </h3>

                    <p className="text-sm text-gray-600 line-clamp-2">
                      {item.desc}
                    </p>
                  </div>

                </motion.div>
              ))}
            </div>

          ) : (
            <p className="text-center text-gray-500 col-span-3">
              No news available
            </p>
          )}

        </div>

      </section>

      {showFooter && <Footer />}
    </div>
  );
}